import React from 'react';
import {
    SmartHeader,
    SmartHeaderAction,
    SmartHeaderInfo,
    SmartHeaderLabel,
    SmartHeaderTitle,
    SmartWrapper,
    TvTable,
    TvTableRow,
    TvTableRowDesc,
    TvTableRowTitle,
    EquipLink
} from './pageStyle';
import VideoYouTube from '~/src/components/VideoYouTube';
import styled from 'styled-components';

const VideoWrapper = styled.div`
  width: 50%;
  position: relative;
  
  @media(max-width: 600px){
    width: 100%; 
    height: 234px;
  }
`;

const VideoVerticalAligner = styled.div`
  width: 100%;
  padding-left: 8px;
  position: absolute;
  bottom: 86px;
  
  @media(max-width: 1024px){
    bottom: 76px;
  }
  
  @media(max-width: 670px){
    bottom: 66px;
  }
  
  @media(max-width: 600px){
    padding-left: 0;
    position: static;
    width: 416px;
    margin: 0 auto;
  }
`;

const smartText = [
    {
        title: 'Как установить приложение?',
        desc: 'На пульте нажмите кнопку Home. Откройте поиск. Введите «Дом.ru Movix», выберите приложение в результатах поиска. Нажмите «Установить». Приятного просмотра.'
    },
    {
        title: 'Для каких телевизоров доступно приложение?',
        desc: 'Для smart-телевизоров LG или Samsung от 2013 года и позднее.'
    },
    {
        title: 'Я Клиент. Сколько телеканалов я могу смотреть в приложении?',
        desc: <ol><li>1. Если у вас цифровое ТВ (есть приставка или CAM-модуль), то с активной услугой <EquipLink href='https://perm.dom.ru/domru-tv/watch-everywhere'>«Смотри везде»</EquipLink> доступны все каналы, которые входят в ваш тариф.
</li>
            <li>2. Если у вас кабельное ТВ, то вам доступно 127 каналов. </li>
            <li>3. Если нет услуги ТВ, то вы можете бесплатно смотреть 20 основных каналов.
                Чтобы расширить список телеканалов, подключите пакет каналов <EquipLink href='https://lk.dom.ru/domrutv/smart-tv'>«МобиСмарт»</EquipLink>.</li></ol>
    },
    {
        title: 'Я не Клиент Дом.ru. Могу ли я пользоваться приложением?',
        desc: 'Да, вы можете бесплатно смотреть 20 основных каналов.'
    },
    {
        title: 'Какая нужна скорость интернета, чтобы смотреть каналы без зависаний?',
        desc: 'Для качественного отображения каналов, фильмов, сериалов на Smart TV рекомендуемая скорость не менее 20 Мбит/с. Чтобы проверить скорость вашего интернета : откройте приложение на в вашем smart-телевизоре, зайдите в раздел «Настройки», пункт «Замер скорости».'
    }
];


export const SmartTv = () => {
    const click = () => {
        document.querySelector('#CallBackForm').scrollIntoView({ block: 'start', behavior: 'smooth' });
    };

    return (
        <SmartWrapper>
            <SmartHeader>
                <SmartHeaderInfo>
                    <SmartHeaderLabel colorBackground='#b6f8d2' colorFont='#15A250' radius='15px'>приложение бесплатно</SmartHeaderLabel>
                    <SmartHeaderTitle>ТВ без приставок и проводов. Не платите за оборудование. Смотрите телеканалы в приложении для Smart TV.</SmartHeaderTitle>
                    <SmartHeaderAction text='Расскажите как смотреть на Smart TV' onClick={click}/>
                </SmartHeaderInfo>
                <VideoWrapper>
                    <VideoVerticalAligner>
                        <VideoYouTube
                            videoId={'lDGJkuotIX0'}
                            eventLabel={'Smart-video'}
                        />
                    </VideoVerticalAligner>
                </VideoWrapper>
            </SmartHeader>
            <TvTable>
                {
                    smartText.map((item, key) =>
                        <TvTableRow key={key}>
                            <TvTableRowTitle>{item.title}</TvTableRowTitle>
                            <TvTableRowDesc>{item.desc}</TvTableRowDesc>
                        </TvTableRow>)
                }


            </TvTable>
        </SmartWrapper>
    );
};
